
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAttachmentListItem as ObcAttachmentListItemElement} from '@oicl/openbridge-webcomponents/dist/components/attachment-list-item/attachment-list-item.js';
 
 
 

 
 export const ObcAttachmentListItem = createComponent({
   react: React,
   tagName: 'obc-attachment-list-item',
   elementClass: ObcAttachmentListItemElement,
   events: {
     
     onAttachmentItemClick: 'attachment-item-click' as EventName<CustomEvent<{label: string}>>,
   }
  });
 
 